// extracted by mini-css-extract-plugin
export var modal = "_dx-0";